import { fetchConToken } from "../helpers/fetch";

const TurnosService = {
  // Cta Cte
  getTurnosCtaCtePorGrupo: (idGrupoFamiliar) => {
    return fetchConToken(`TurnosFacturas/traerCtaCtePorGrupoFamiliar/${idGrupoFamiliar}`);
  },
  getTurnosCtaCte: (idAfiliado, nroDocumento, idObraSocial) => {
    return fetchConToken(`TurnosFacturas/traerCtaCtePorAfiliado/${idAfiliado}/${nroDocumento}/${idObraSocial}`);
  },
  getDetalleComprobanteCtaCte: (turno) => {
    return fetchConToken(
      // `TurnosFacturas/traerDetalleComprobante?idAfiliado=${turno.idAfiliado}&idTipoComprobante2=${turno.idTipoComprobante2}&nroComprobante2=${turno.nroComprobante2}&fechaComprobante2=${turno.fechaComprobante2}&nroComprobante=${turno.nroComprobante}`
      `TurnosFacturas/traerDetalleComprobante?idAfiliado=${
        turno.idAfiliado
      }&idTipoComprobante2=${
        turno.idTipoComprobante2
      }&nroComprobante2=${
        turno.nroComprobante2
      }&fechaComprobante2=${
        turno.fechaComprobante2
      }&nroComprobante=${
        turno.nroComprobante
      }&idObraSocial=${
        turno.idObraSocial
      }&nroDocumento=${
        turno.nroDocumento
      }`
    );
  },
  postPagoTurnoCtaCte: (data) => {
    return fetchConToken(`TurnosFacturas/nuevoPagoTurno`, data, "POST");
  },
  postPagoTurnoACuenta: (data) => {
    return fetchConToken(`TurnosFacturas/nuevoPagoACuenta`, data, "POST");
  },
  //USUARIO OSPE
  getAbmUsuarioPorIdProfesional: (idProfesional) => {
    return fetchConToken(`RelEfectorOspe/traerPorIdProfesional/${idProfesional}`);
  },
  putAbmUsuarioPorIdProfesional: (data) => {
    return fetchConToken(`RelEfectorOspe`, data, "PUT");
  },
  updateUsuarioOspeTurb001: (data) => {
    return fetchConToken(`RelEfectorOspe/updateUsuarioOspeTurb001`, data, "PUT");
  },
};

export { TurnosService as default };
